import React, { useMemo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import description from "../../../../src/assets/images/description.svg";
import Exclamation from "../../../assets/images/Exclamation.svg";
import TitleDescription from "../../../components/newMotorPolicy/titleDescription/titleDescription";
import useFileClaimFlow from "../../../hooks/useFileClaimFlow";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import { FILE_CLAIM_FLOW, REQUIRED_DOCS_INFO_DATA } from "./data";
import FileClaimMotorLayout from "./fileClaimMotorLayout";
import {
  BODILY_INJURY,
  PROPERTY_DAMAGE,
  VEHICLE_DAMAGE,
} from "./NonSolidarityUser/data";
import { AxiosStrapi } from "../../../redux/axiosInstance";
import { STRAPI_BASE_URL } from "../../../api/baseURL";

const BIA_NOTICE_LINK_FALLBACK = "https://s3.eu-central-2.wasabisys.com/bia2025/wp-media-folder-bahrain-insurance-association-bahrain/wp-content/uploads/2021/09/minor-accident-form.pdf";

function RequiredDocsInfoPage({ selectedInsuredType }) {
  const translate = useLanguageTranslate();
  const { t } = useTranslation();
  const { handleNextSubstep, currentStep, flowType } = useFileClaimFlow();
  const [showBiaNotice, setShowBiaNotice] = useState(false);
  const [biaNoticeLink, setBiaNoticeLink] = useState(BIA_NOTICE_LINK_FALLBACK);

  useEffect(() => {
    AxiosStrapi.get("/api/users?filters[username][$eq]=Claim BIA Notice")
      .then((res) => {
        const user = res.data?.[0];
        if (user?.confirmed) {
          setShowBiaNotice(true);
        }
      })
      .catch(() => {});

    AxiosStrapi.get("/api/upload/files?filters[name][$eq]=minor-accident-form.pdf")
      .then((res) => {
        const file = res.data?.[0];
        if (file?.url) {
          setBiaNoticeLink(`${STRAPI_BASE_URL}${file.url}`);
        }
      })
      .catch(() => {});
  }, []);

  const continueClickHanlder = () => {
    handleNextSubstep();
  };

  const { docs, alertMessage } = useMemo(() => {
    if (flowType == FILE_CLAIM_FLOW) {
      return REQUIRED_DOCS_INFO_DATA.solidarity_user;
    } else if (selectedInsuredType == VEHICLE_DAMAGE) {
      return REQUIRED_DOCS_INFO_DATA.non_solidarity_vehicle_damage;
    } else if (selectedInsuredType == PROPERTY_DAMAGE) {
      return REQUIRED_DOCS_INFO_DATA.non_solidarity_property_damage;
    } else if (selectedInsuredType == BODILY_INJURY) {
      return REQUIRED_DOCS_INFO_DATA.non_solidarity_bodily_injury;
    } else return {};
  }, [flowType]);

  console.log(selectedInsuredType);

  return (
    <FileClaimMotorLayout btn_onClick={continueClickHanlder}>
      <div className="flex flex-col items-center mx-auto w-[500px] max-w-[100%] PolicyTypePage max767:p-4 max767:pt-5">
        <TitleDescription
          title={t("motorInsurance.fileAClaimFlow.requiredDocsPage.title")}
          description={t(
            "motorInsurance.fileAClaimFlow.requiredDocsPage.description"
          )}
        />
        <div className="infoCard documents-section flex flex-col items-start gap-2 self-stretch bg-[#F6F8F9] p-4 rounded-2xl">
          <div className="flex align-middle gap-2">
            <h3 className="documents-title text-[#48535B] text-base not-italic font-semibold leading-6 tracking-[-0.16px] flex gap-2">
              <img src={description} alt="docs" />
              {translate("Documents", "المستندات")}
            </h3>
          </div>
          <ul className="documents-list pl-12 rtl:pr-12 max767:pl-[24px]">
            {docs?.map((doc, index) => (
              <li
                className=" gap-2 mb-2 inline-flexflex align-middle text-[#48535B] text-sm not-italic font-normal leading-5 tracking-[-0.14px]"
                key={index}
              >
                <span>{translate(doc.label_en, doc.label_ar)}</span>
              </li>
            ))}
          </ul>
        </div>
        {selectedInsuredType != PROPERTY_DAMAGE &&
          selectedInsuredType != BODILY_INJURY && (
            <div className="warning-section flex items-start gap-4 self-stretch border bg-[#FDE9D2] p-4 rounded-[10px] border-solid border-[#FBC98E] mt-4">
              <img
                className="warning-icon"
                src={Exclamation}
                alt="exclamation"
              />
              <p className="warning-text text-[#252C32] text-sm not-italic font-semibold leading-6 tracking-[-0.084px]">
                {translate(alertMessage.label_en, alertMessage.label_ar)}
              </p>
            </div>
          )}
        {showBiaNotice && (
            <div className="flex items-start gap-4 self-stretch border bg-[#D4EDFF] p-4 rounded-[10px] border-solid border-[#7EC8F2] mt-4">
              <img
                className="warning-icon"
                src={Exclamation}
                alt="notice"
              />
              <p className="text-[#252C32] text-sm not-italic font-normal leading-6 tracking-[-0.084px]">
                {translate(
                  "If you are unable to register accident details on the eTraffic App, please use the Accidents Registration Form via the link below and upload it in the Incident Report section:",
                  "في حال تعذّر تسجيل تفاصيل الحادث عبر تطبيق المرور للخدمات الإلكترونية eTraffic يرجى استخدام استمارة تسجيل الحوادث عبر الرابط التالي ورفعها في قسم تقرير الحادث:"
                )}
                <a
                  href={biaNoticeLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#0066CC] underline font-semibold block mt-1"
                >
                  {translate("Accidents Registration Form", "استمارة تسجيل الحوادث")}
                </a>
              </p>
            </div>
          )}
      </div>
    </FileClaimMotorLayout>
  );
}

export default RequiredDocsInfoPage;
